import { render, staticRenderFns } from "./confirm_email.vue?vue&type=template&id=c44ef1ba&lang=pug&"
import script from "./confirm_email.ts?vue&type=script&lang=ts&"
export * from "./confirm_email.ts?vue&type=script&lang=ts&"
import style0 from "./confirm_email.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports